const sha256 = require('js-sha256');

export const generateSignature = (deviceId, source, epoch) => {
  const string = `${deviceId}|${source}|${epoch}`;
  const hash = sha256(string);
  return hash;
};
